import styled from 'styled-components';

export const HeaderLogoBox = styled.div`
  position: relative;
  margin-bottom: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 70px;
`;

export const HeaderLogo = styled.img`
  max-height: 45px;
  cursor: pointer;
`;

export const BurgerButton = styled.div`
  position: fixed;
  top: 16px;
  left: 16px;
  z-index: 1001;
  background: white;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  padding: 4px;
  
  @media (min-width: 1201px) {
    display: none;
  }
  
  .ant-btn {
    border: none;
    box-shadow: none;
    color: #1890ff;
    
    &:hover {
      background-color: #f0f0f0;
    }
  }
`;
